import React from 'react';
import clsx from 'clsx';
import {
  ListQueryProps,
} from 'pages/Dashboard/pages/Todos/types';
import QueryTable from 'pages/Dashboard/pages/Todos/Overview/QueryTable';

export default function Overview({ classes, ...query }: ListQueryProps) {
  const wrapperClasses = clsx('relative flex flex-col flex-1 overflow-y-hidden nw-todo-list', classes);
  return (
    <div className={wrapperClasses}>
      <div className="w-full h-full">
        <QueryTable {...query} />
      </div>
    </div>
  );
}
